module.exports = __webpack_public_path__ + "img/tieloa.feaba315.png";